import { combineReducers } from "redux";

import { sessionReducer } from "./session/reducers";
import { protocolWizardReducer } from './create-protocol-wizard/reducers';
import { mailProtocolWizardReducer } from './mail-protocol-wizard/reducers';
import { printAndSendWizardReducer } from './print-and-send-wizard/reducers';
import { appNavigationReducer } from './app-navigation/reducers';

import sessionActions from './session/actions';
import protocolWizardActions from './create-protocol-wizard/actions';
import mailProtocolWizardActions  from './mail-protocol-wizard/actions';
import printAndSendWizardActions from './print-and-send-wizard/actions';
import appNavigationActions from './app-navigation/actions';

const reduxActions = {
    sessionActions,
    protocolWizardActions,
    mailProtocolWizardActions,
    printAndSendWizardActions,
    appNavigationActions
}
export { reduxActions }

export const rootReducer = combineReducers({
    sessionReducer: sessionReducer,
    protocolWizardReducer: protocolWizardReducer,
    mailProtocolWizardReducer: mailProtocolWizardReducer,
    printAndSendWizardReducer: printAndSendWizardReducer,
    appNavigationReducer: appNavigationReducer,
})

export type RootState = ReturnType<typeof rootReducer>